import { DownOutlined } from '@ant-design/icons'
import { Button, ConfigProvider, Dropdown, Space } from 'antd'
import React, { memo, useCallback } from 'react'

const DropdownClickButton = ({
  buttonLeftProps,
  buttonRightProps,
  id = 'dropdow-click-button-id',
  overlayClassName = '',
  ...props
}) => {
  const getPopupContainer = useCallback(() => document.getElementById(id), [id])

  const dropdownProps = {
    getPopupContainer,
    arrow: true,
    placement: 'topRight',
    trigger: ['click'],
    overlayClassName: `text-left ${overlayClassName}`,
    ...props,
  }

  const leftButton = (
    <ConfigProvider theme={{ components: { Button: { contentFontSize: 13 } } }}>
      <Button {...buttonLeftProps} />
    </ConfigProvider>
  )

  const rightButton = (
    <Button icon={<DownOutlined style={{ fontSize: 10 }} />} {...buttonRightProps} />
  )

  // Kalau tombol kiri punya aksi sendiri (onClick), dropdown hanya dibuka lewat
  // caret kanan. Kalau tidak, seluruh tombol jadi trigger dropdown (perilaku lama).
  if (buttonLeftProps?.onClick) {
    return (
      <div style={{ position: 'relative' }} id={id}>
        <Space.Compact>
          {leftButton}
          <Dropdown {...dropdownProps}>{rightButton}</Dropdown>
        </Space.Compact>
      </div>
    )
  }

  return (
    <div style={{ position: 'relative' }} id={id}>
      <Dropdown {...dropdownProps}>
        <div>
          <Space.Compact>
            {leftButton}
            {rightButton}
          </Space.Compact>
        </div>
      </Dropdown>
    </div>
  )
}

export default memo(DropdownClickButton)
